import {SessionState} from "./types"
import {getSessionState} from "./selectors"
import {useAppSelector} from "../../hooks/use-app-selector"
import {SliceSelector} from "../../../types/store"

export const useSessionStateSelector = <TSelected = unknown>(
    selector: SliceSelector<SessionState, TSelected>
): TSelected => {
    return useAppSelector((state) => selector(getSessionState(state)))
}
